import VueDragscroll from 'vue-dragscroll'

import { definePlugin } from '/@/app'
import { vBackground } from '/@/directives/background'
import { vAuth } from '/@/directives/permission'
import { vPreloadLink } from '/@/directives/preload-link'
import { vSanitize } from '/@/directives/sanitize'
import { vTooltip } from '/@/directives/tooltip'
export default definePlugin(({ app }) => {
  // register global v-preload-link directive
  app.directive('preload-link', vPreloadLink)

  // register global v-tootltip directive
  app.directive('tooltip', vTooltip)

  // register global v-background directive
  app.directive('background', vBackground)

  // register global v-permission directive
  app.directive('auth', vAuth)

  // register global v-sanitize directive
  app.directive('sanitize', vSanitize)

  // register global v-dragscroll directive
  app.use(VueDragscroll)
})
